<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 text-xs text-gray-500 align-top">
      <a role="button" class="underline" @click.prevent="showContactRequest">
        {{ fullName }}
      </a>
      <div class="mt-1">
        <span
          v-if="typeof contactRequest.unsubscribe_request_id === 'string'"
          class="inline-flex items-center rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-800"
          >{{ $t('global.unsubscribed') }}</span
        >
      </div>
    </td>
    <td class="px-4 py-4 text-xs text-gray-500 text-right align-top">
      {{ assigneeFullName }}
    </td>
    <td class="px-4 py-4 text-xs text-gray-500 text-right align-top">
      {{ pipelineStage ? pipelineStage.name : '-' }}
    </td>
    <td class="px-4 py-4 text-xs text-gray-500 text-right">
      <span class="whitespace-nowrap">{{ createdAt }}</span>
      <div>
        {{ createdAtFromNow }}
      </div>
    </td>
  </tr>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fullName() {
      return `${this.contactRequest?.full_name || 'Name not available'}`.trim();
    },
    assigneeFullName() {
      if (!this.contactRequest.user_id) {
        return this.$t('global.unassigned');
      }

      return this.contactRequest?.user?.fullName || this.$t('not_available');
    },
    pipelineStage() {
      return this.contactRequest.pipelineStage;
    },
    createdAt() {
      return moment.utc(this.contactRequest.created_at).local().format('YYYY-MM-DD HH:mm');
    },
    createdAtFromNow() {
      return moment.utc(this.contactRequest.created_at).local().fromNow();
    },
  },
  methods: {
    showContactRequest() {
      this.$modal.show({
        component: () => import('Components/ContactRequests/ContactRequestModal.vue'),
        props: {
          contactRequestId: this.contactRequest.id,
        },
        on: {
          'pipeline-stage-change': () => {
            this.$emit('contact-request-updated');
          },
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
